module.exports = __webpack_public_path__ + "static/media/banner-phone-nl@2x.48ba207c.png";